export const ButtonStyle = {
  borderRadius: '50px',
  fontSize: '12px',
};
